export default __webpack_public_path__ + "static/Perroquet-site-web-membre-french-tech-9f357c279ad097e1af7b68d42fa55b01.jpg";